import { pushToDataLayer } from '@/app/lib/analytics/analyticsTracking'
import { analyticsTags } from '@/app/lib/analytics/analyticsEventTags'
import { NavIds } from './nav'

export const trackLeftNavAnalyticsEvents = (navId: NavIds) => {
	const {
		leftNavBI,
		leftNavRecruiting,
		leftNavAgentManagement,
		leftNavLogout,
		leftNavCannyFeedback,
	} = analyticsTags

	switch (navId) {
		case NavIds.BusinessIntelligence:
		case NavIds.BI:
			pushToDataLayer(leftNavBI)
			break
		case NavIds.Recruiting:
			pushToDataLayer(leftNavRecruiting)
			break
		case NavIds.AgentManagement:
			pushToDataLayer(leftNavAgentManagement)			
			break
		case NavIds.Feedback:
			pushToDataLayer(leftNavCannyFeedback)
			break
		case NavIds.Signout:
			pushToDataLayer(leftNavLogout)
			break
		default:
			break
	}
}
